import React from 'react';
import classNames from 'classnames';
import styles from './grid-layout.module.css';
import { useMediaQuery } from '../../../library';
function generateGridLayoutStyles(props, isMobile, isTablet) {
    var _a;
    var styles = {};
    if (!!props.columnCount) {
        if (isMobile) {
            styles.gridTemplateColumns = "repeat(".concat(props.columnCount > 1 ? props.columnCount - 2 : 1, ", minmax(0px, 1fr))");
        }
        else if (isTablet) {
            styles.gridTemplateColumns = "repeat(".concat(props.columnCount > 1 ? props.columnCount - 1 : 1, ", minmax(0px, 1fr))");
        }
        else
            styles.gridTemplateColumns = "repeat(".concat(props.columnCount, ", minmax(0px, 1fr))");
    }
    if (!!props.columnMinWidth) {
        styles.gridTemplateColumns = "repeat(auto-fit, minmax(".concat(!!props.columnMinWidth ? props.columnMinWidth : 0, "px, 1fr))");
    }
    if (!!props.responsive) {
        if (isMobile) {
            styles.gridTemplateColumns = "repeat(".concat(props.responsive ? 'auto-fit' : 1, ", minmax(0px, 1fr))");
        }
        else if (isTablet) {
            styles.gridTemplateColumns = "repeat(".concat(props.responsive ? 'auto-fit' : 2, ", minmax(0px, 1fr))");
        }
        else
            styles.gridTemplateColumns = "repeat(".concat(props.responsive ? 'auto-fit' : 3, ", minmax(0px, 1fr))");
    }
    styles.gap = "".concat((_a = props.gap) !== null && _a !== void 0 ? _a : 15, "px");
    return styles;
}
export function GridLayout(props) {
    var isMobile = useMediaQuery("screen and (max-width: 580px)");
    var isTablet = useMediaQuery("screen and (max-width: 980px)");
    if (((!!props.columnCount && (!!props.columnMinWidth || !!props.responsive)) || (!!props.columnMinWidth && (!!props.columnCount || !!props.responsive)) || (!!props.responsive && (!!props.columnCount || !!props.columnMinWidth))) && process.env.NODE_ENV !== 'production')
        throw new Error("<GridLayout>: Use \"columnCount\", \"columnMinWidth\" and \"responsive\" separately.");
    var customStyles = generateGridLayoutStyles(props, isMobile, isTablet);
    return (React.createElement("div", { style: customStyles, className: classNames(styles.gridLayoutChildren, "kplr_gridLayoutChildren") }, props.children));
}
export default GridLayout;
